import { BenefitDetailsForClass } from 'core/application/csiDashboard/csiSearch/getBenefitClasses'

import Item from 'common/components/dataDisplay/ItemWithoutSpacing'

import { parseZoneFormat } from '../../../../../common/dateFormatters'

interface BenefitHeaderProps {
  benefitDetails: BenefitDetailsForClass
  translate: (key: string) => string
}

const BenefitHeader = ({ benefitDetails, translate }: BenefitHeaderProps) => {
  return (
    <div>
      <div>
        <h5>{translate('csi-dashboard.benefit-classes.benefit-details')}</h5>
      </div>
      <div className="flex flex__space_between">
        <Item
          translate={translate}
          title={translate('csi-dashboard.benefit-classes.start-date')}
          text={parseZoneFormat(benefitDetails.startDate)}
        />
        <Item
          translate={translate}
          title={translate('csi-dashboard.benefit-classes.end-date')}
          text={parseZoneFormat(benefitDetails.endDate)}
        />
        <Item
          translate={translate}
          title={translate('csi-dashboard.benefit-classes.runOutDays')}
          text={`${parseZoneFormat(benefitDetails.runOutDate)} at 11:59pm`}
        />
        <Item
          translate={translate}
          title={translate('csi-dashboard.benefit-classes.created-on')}
          text={parseZoneFormat(benefitDetails.createdOn)}
        />
        <Item
          translate={translate}
          title={translate('csi-dashboard.benefit-classes.created-by')}
          text={benefitDetails.createdBy}
        />
      </div>
    </div>
  )
}

export default BenefitHeader
